import { actions } from './constants'

const initialState = {
  fetching: undefined,
  officers: [],
  error: '',
}

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.FETCH_OFFICERS:
      return {
        ...state,
        fetching: true,
      }

    case actions.FETCH_OFFICERS_SUCCESS:
      return {
        ...state,
        fetching: false,
        officers: payload.officers,
      }

    case actions.FETCH_OFFICERS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: payload.error,
      }

    case actions.SUBMIT_FAIL:
      return {
        ...state,
        error: payload.error,
      }

    case actions.CLOSE:
      return initialState

    default:
      return state
  }
}

export default reducer
